import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Box, Typography, Alert, CircularProgress } from '@mui/material';

const CancelAppointment = () => {
  const location = useLocation();
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const tenantId = params.get('tenantId');

    if (!token || !tenantId) {
      setMessage('Ungültiger Stornierungslink.');
      setLoading(false);
      return;
    }

    // Deine Cloud-Function-URL:
    axios.post('https://cancelappointment-ce72zbmxaq-uc.a.run.app', 
      { token, tenantId },
      { headers: { 'Content-Type': 'application/json' } }
    )
    .then(() => {
      setMessage('Ihr Termin wurde erfolgreich storniert.');
    })
    .catch((error) => {
      setMessage(
        'Fehler beim Stornieren des Termins. Bitte versuchen Sie es später erneut. ' +
        (error.response?.data || error.message)
      );
    })
    .finally(() => setLoading(false));
  }, [location.search]);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Termin Stornierung
      </Typography>
      {loading ? (
        <CircularProgress sx={{ display: 'block', my: 2 }} />
      ) : (
        <Alert severity={message.includes('erfolgreich') ? 'success' : 'error'}>
          {message}
        </Alert>
      )}
    </Box>
  );
};

export default CancelAppointment;
